export default __webpack_public_path__ + "static/media/blank.631a4090.svg";